var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-header',{attrs:{"mode":"ios"}},[_c('ion-toolbar',{attrs:{"mode":"ios"}},[_c('ion-title',[_c('img',{staticClass:"prime-main-menu-logomark",attrs:{"src":require("../../assets/MyPCP-Health-Education-Logo.svg")}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }